import React from 'react';
import {
  ReactOriginal,
  JavascriptPlain,
  LaravelOriginal,
  DjangoPlain,
  GithubOriginal,
  GitlabOriginal,
  TensorflowOriginal,
  GitPlain,
  IonicOriginal,
  ConfluencePlain,
  GraphqlPlain,
  GatsbyOriginal,
  AngularOriginal,
  TerraformOriginal,
  SlackOriginal,
  JiraOriginal,
  NodejsOriginal,
  TypescriptOriginal,
  FirebaseOriginal,
  BootstrapOriginal,
  RedisOriginal,
  AntdesignOriginal,
  GithubactionsOriginal,
  KubernetesOriginal,
  RancherOriginal,
  MongodbOriginal,
  SassOriginal,
  ReduxOriginal,
  AndroidOriginal,
  PostgresqlOriginal,
  MysqlOriginal,
  DockerOriginal,
  HerokuOriginal,
  LinuxOriginal,
  PostmanOriginal,
  PythonOriginal,
  JavaOriginal,
  SpringOriginal,
  ArduinoOriginal,
  ViteOriginal,
  TailwindcssOriginal,
  FastapiOriginal,
  RabbitmqOriginal,
  COriginal,
  CplusplusOriginal,
} from 'devicons-react';

// ✅ Use FA v5 bundle consistently
import { FaSpotify, FaSymfony, FaTelegram, FaAws, FaApple, FaReact } from 'react-icons/fa';
import { SiGreensock } from 'react-icons/si';

/* ---------------- Shared types ---------------- */
export type TagIconType = React.ComponentType<any>;

type TagDef = {
  text: string;
  color: string;
  icon: TagIconType; // store component type (not JSX element)
  years?: string;
  link?: string;
  image?: string;
};

/* ---------------- Custom SVG icon components (typed) ---------------- */
const KeycloakIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <path
      d="M786.2 395.5h-80.6c-1.5 0-3-.8-3.7-2.1l-64.7-112.2c-.8-1.3-2.2-2.1-3.8-2.1h-264c-1.5 0-3 .8-3.7 2.1l-67.3 116.4-64.8 112.2c-.7 1.3-.7 2.9 0 4.3l64.8 112.2 67.2 116.5c.7 1.3 2.2 2.2 3.7 2.1h264.1c1.5 0 3-.8 3.8-2.1L702 630.6c.7-1.3 2.2-2.2 3.7-2.1h80.6c2.7 0 4.8-2.2 4.8-4.8V400.4c-.1-2.7-2.3-4.9-4.9-4.9zM477.5 630.6l-20.3 35c-.3.5-.8 1-1.3 1.3-.6.3-1.2.5-1.9.5h-40.3c-1.4 0-2.7-.7-3.3-2l-60.1-104.3-5.9-10.3-21.6-36.9c-.3-.5-.5-1.1-.4-1.8 0-.6.2-1.3.5-1.8l21.7-37.6 65.9-114c.7-1.2 2-2 3.3-2H454c.7 0 1.4.2 2.1.5.5.3 1 .7 1.3 1.3l20.3 35.2c.6 1.2.5 2.7-.2 3.8l-65.1 112.8c-.3.5-.4 1.1-.4 1.6 0 .6.2 1.1.4 1.6l65.1 112.7c.9 1.5.8 3.1 0 4.4zm202.1-116.7L658 550.8l-5.9 10.3L592 665.4c-.7 1.2-1.9 2-3.3 2h-40.3c-.7 0-1.3-.2-1.9-.5-.5-.3-1-.7-1.3-1.3l-20.3-35c-.9-1.3-.9-2.9-.1-4.2l65.1-112.7c.3-.5.4-1.1.4-1.6 0-.6-.2-1.1-.4-1.6l-65.1-112.8c-.7-1.2-.8-2.6-.2-3.8l20.3-35.2c.3-.5.8-1 1.3-1.3.6-.4 1.3-.5 2.1-.5h40.4c1.4 0 2.7.7 3.3 2l65.9 114 21.7 37.6c.3.6.5 1.2.5 1.8 0 .4-.2 1-.5 1.6z"
      fill="currentColor"
    />
  </svg>
);

const GooglePlayConsoleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 283" preserveAspectRatio="xMidYMid" {...props}>
    <g>
      <path d="M0,251.172514 L0,31.3252701 C0,7.24403011 26.3675454,-7.80674488 47.4739401,4.24270254 L240.176825,114.161911 C261.274392,126.202531 261.274392,156.286426 240.176825,168.318218 L47.4739401,278.246254 C26.3763728,290.286874 0,275.244927 0,251.172514 Z" fill="#2F80ED" />
      <path d="M192.941225,87.2205822 L91.6905571,145.525784 L72.3584766,111.27534 C70.190947,107.425885 66.5737479,104.603325 62.3128567,103.436579 C58.0466395,102.239185 53.4799324,102.778685 49.6101791,104.937242 L0,132.478836 L0,166.252599 L52.7527456,136.954345 L72.1731005,171.381338 C74.3446492,175.221272 78.0521715,178.090188 82.3423044,179.255409 C86.6652503,180.417606 91.2723262,179.824271 95.1597386,177.604679 L222.663195,104.169256 L192.941225,87.2205822 Z" fill="#CCF6FF" />
    </g>
  </svg>
);

const SentryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M74.012 13.328a11.939 11.939 0 0 0-20.45 0L36.734 42.145a82.34 82.34 0 0 1 45.383 68.164H70.309a70.78 70.78 0 0 0-39.527-58.09l-15.57 26.926a40.72 40.72 0 0 1 23.598 31.113H11.68a1.94 1.94 0 0 1-1.582-2.836l7.516-12.781a27.4 27.4 0 0 0-8.59-4.859l-7.445 12.781c-1.562 2.684-1.988 5.887-1.172 8.883s2.789 5.547 5.492 7.07a11.9 11.9 0 0 0 5.781 1.535h37.152a49.63 49.63 0 0 0-20.453-44.258l5.902-10.227a61.04 61.04 0 0 1 26.336 54.484H92.09a91.74 91.74 0 0 0-41.953-81.305l11.938-20.453a1.97 1.97 0 0 1 2.684-.691c1.355.742 51.879 88.898 52.828 89.922a1.95 1.95 0 0 1-.035 1.949 1.96 1.96 0 0 1-1.707.941h-12.168a104 104 0 0 1 0 9.742h12.219a11.73 11.73 0 0 0 11.813-11.789 11.47 11.47 0 0 0-1.582-5.832zm0 0"
      fill="currentColor"
    />
  </svg>
);

const RedashIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 35" {...props}>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(6 1)" fillRule="nonzero">
        <path d="M12,25.3846154 C20.7263387,20.2114164 24.8265686,18.2206014 24.3006897,19.4121704 C23.7748108,20.6037394 19.6745809,25.133016 12,33 L12,25.3846154 Z" fill="#FF7964" />
        <path d="M26,13 C26,20.1864237 20.1850584,26 13,26 C5.81494155,26 0,20.172447 0,13 C0.000240455756,5.82755297 5.81518201,0 13,0 C20.184818,0 26,5.82755297 26,13 Z" fill="#FF7964" />
        <path
          d="M4.8408991,14.7263528 L6.76088775,14.7263528 C7.22469914,14.7276812 7.60033102,15.0704218 7.60178685,15.4936208 L7.60178685,17.2327321 C7.60033102,17.655931 7.22469914,17.9986716 6.76088775,18 L4.8408991,18 C4.37708771,17.9986716 4.00145583,17.655931 4,17.2327321 L4,15.4936208 C4.0013242,15.0703719 4.37703296,14.7275611 4.8408991,14.7263528 Z M9.28358505,10.8900132 L11.1895909,10.8900132 C11.6534023,10.8913416 12.0290341,11.2340822 12.03049,11.6572811 L12.03049,17.2327321 C12.0290341,17.655931 11.6534023,17.9986716 11.1895909,18 L9.28358505,18 C8.81977367,17.9986716 8.44414179,17.655931 8.44268595,17.2327321 L8.44268595,11.6572811 C8.44401016,11.2340322 8.81971891,10.8912215 9.28358505,10.8900132 Z M13.7122882,13 L15.6322768,13 C16.0960882,13.0013284 16.4717201,13.344069 16.4731759,13.7672679 L16.4731759,17.2327321 C16.4717201,17.655931 16.0960882,17.9986716 15.6322768,18 L13.7122882,18 C13.2484768,17.9986716 12.8728449,17.655931 12.8713891,17.2327321 L12.8713891,13.7672679 C12.8727133,13.344019 13.248422,13.0012083 13.7122882,13 Z M18.2530951,8 L20.1591009,8 C20.6229123,8.00132836 20.9985442,8.344069 21,8.76726793 L21,17.2327321 C20.9985442,17.655931 20.6229123,17.9986716 20.1591009,18 L18.2530951,18 C17.7892837,17.9986716 17.4136518,17.655931 17.412196,17.2327321 L17.412196,8.76726793 C17.4135202,8.34401904 17.7892289,8.00120825 18.2530951,8 Z"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </svg>
);

const AppCenterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-100.075 -20.786 712.075 514.786" {...props}>
    <rect x="-100.075" y="-20.786" width="712.075" height="514.786" fill="currentColor" />
  </svg>
);

const ServerlessIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-9.5 0 50 31" {...props}>
    <path
      d="M2,22.419H6.956L5.42,27H2ZM2,13.71H9.875L8.34,18.29H2ZM2,5H12.794L11.259,9.581H2ZM17.679,5H30V9.581H16.143ZM13.224,18.291,14.76,13.71H30v4.581Zm-1.383,4.128H30V27H10.305Z"
      fill="#fd5750"
      fillRule="evenodd"
    />
  </svg>
);

const DynamoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 289" preserveAspectRatio="xMidYMid" {...props}>
    <rect width="256" height="289" rx="24" fill="currentColor" />
  </svg>
);

const ExpressIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="currentColor"
      d="M126.67 98.44c-4.56 1.16-7.38.05-9.91-3.75-5.68-8.51-11.95-16.63-18-24.9-.78-1.07-1.59-2.12-2.6-3.45C89 76 81.85 85.2 75.14 94.77c-2.4 3.42-4.92 4.91-9.4 3.7l26.92-36.13L67.6 29.71c4.31-.84 7.29-.41 9.93 3.45 5.83 8.52 12.26 16.63 18.67 25.21 6.45-8.55 12.8-16.67 18.8-25.11 2.41-3.42 5-4.72 9.33-3.46-3.28 4.35-6.49 8.63-9.72 12.88-4.36 5.73-8.64 11.53-13.16 17.14-1.61 2-1.35 3.3.09 5.19C109.9 76 118.16 87.1 126.67 98.44M1.33 61.74c.72-3.61 1.2-7.29 2.2-10.83 6-21.43 30.6-30.34 47.5-17.06C60.93 41.64 63.39 52.62 62.9 65H7.1c-.84 22.21 15.15 35.62 35.53 28.78 7.15-2.4 11.36-8 13.47-15 1.07-3.51 2.84-4.06 6.14-3.06-1.69 8.76-5.52 16.08-13.52 20.66-12 6.86-29.13 4.64-38.14-4.89C5.26 85.89 3 78.92 2 71.39c-.15-1.2-.46-2.38-.7-3.57q.03-3.04.03-6.08m5.87-1.49h50.43c-.33-16.06-10.33-27.47-24-27.57-15-.12-25.78 11.02-26.43 27.57"
    />
  </svg>
);

const MercadoPagoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-16 0 120 60" {...props}>
    <rect x="-16" y="0" width="120" height="60" rx="8" fill="currentColor" />
  </svg>
);

const ExpoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" {...props}>
    <path d="M24.292 15.547c1.968 0.131 3.729-1.213 4.115-3.145-0.475-0.735-1.287-1.177-2.161-1.177-2.272-0.052-3.491 2.651-1.953 4.323zM15.115 4.697l5.359-3.104-1.708-0.963-7.391 4.281 0.589 0.328 1.119 0.629 2.032-1.176zM21.161 1.307c0.089 0.027 0.161 0.1 0.188 0.188l2.484 7.593c0.047 0.131-0.005 0.272-0.125 0.344-1.968 1.156-2.916 3.489-2.317 5.693 0.656 2.391 2.937 3.953 5.401 3.703 0.135-0.011 0.265 0.073 0.307 0.203l2.563 7.803c0.041 0.131-0.011 0.271-0.125 0.344l-7.859 4.771c-0.037 0.021-0.084 0.036-0.131 0.036-0.068 0.016-0.14 0-0.203-0.041l-2.765-1.797c-0.048-0.031-0.084-0.077-0.109-0.129l-5.396-12.896-8.219 4.875c-0.016 0.011-0.037 0.021-0.052 0.032-0.084 0.036-0.183 0.025-0.261-0.021l-1.859-1.093c-0.136-0.073-0.188-0.245-0.115-0.381l7.953-15.749c0.025-0.057 0.077-0.104 0.135-0.131l7.959-4.609c0.088-0.052 0.197-0.057 0.292-0.005zM12.839 6.407l-1.932-1.089-7.693 15.229 1.396 0.823 6.631-9.015c0.063-0.089 0.167-0.136 0.271-0.12 0.104 0.011 0.192 0.077 0.235 0.177l7.228 17.296 1.933 1.251-8.063-24.552zM26.245 16.964c-2.256 0-3.787-2.292-2.923-4.376 0.86-2.083 3.563-2.619 5.156-1.025 0.595 0.593 0.928 1.396 0.928 2.235 0.005 1.749-1.412 3.167-3.161 3.167z" />
  </svg>
);

const VercelIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M24 22.525H0l12-21.05 12 21.05z" />
  </svg>
);

const CloudflareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path d="M8.16 23h21.177v-5.86 l-4.023-2.307-.694-.3-16.46.113z" fill="#fff" />
    <path
      d="M22.012 22.222c.197-.675.122-1.294-.206-1.754-.3-.422-.807-.666-1.416-.694l-11.545-.15c-.075 0-.14-.038-.178-.094s-.047-.13-.028-.206c.038-.113.15-.197.272-.206l11.648-.15c1.38-.066 2.88-1.182 3.404-2.55l.666-1.735a.38.38 0 0 0 .02-.225c-.75-3.395-3.78-5.927-7.4-5.927-3.34 0-6.17 2.157-7.184 5.15-.657-.488-1.5-.75-2.392-.666-1.604.16-2.9 1.444-3.048 3.048a3.58 3.58 0 0 0 .084 1.191A4.84 4.84 0 0 0 0 22.1c0 .234.02.47.047.703.02.113.113.197.225.197H21.58a.29.29 0 0 0 .272-.206l.16-.572z"
      fill="#f38020"
    />
    <path
      d="M25.688 14.803l-.32.01c-.075 0-.14.056-.17.13l-.45 1.566c-.197.675-.122 1.294.206 1.754.3.422.807.666 1.416.694l2.457.15c.075 0 .14.038.178.094s.047.14.028.206c-.038.113-.15.197-.272.206l-2.56.15c-1.388.066-2.88 1.182-3.404 2.55l-.188.478c-.038.094.028.188.13.188h8.797a.23.23 0 0 0 .225-.169A6.41 6.41 0 0 0 32 21.106a6.32 6.32 0 0 0-6.312-6.302"
      fill="#faae40"
    />
  </svg>
);

const ElectronIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512" {...props}>
    <circle cx="256" cy="256" r="200" fill="currentColor" />
  </svg>
);

/* -------- react-icons wrapper with fixed Spotify color (typed & simple) -------- */
/* -------- react-icons wrapper with fixed Spotify color (no JSX to fix TS2786) -------- */
const SpotifyGreenIcon: React.FC<any> = (props) => {
  const Icon = FaSpotify as unknown as React.ComponentType<any>;
  return React.createElement(Icon, { ...props, color: '#1ed760' });
};


/* --------------------------------- Tags map --------------------------------- */
export const tags: Record<string, TagDef> = {
  Linux: {
    text: 'Linux',
    color: '#FCC624',
    icon: LinuxOriginal,
    years: '+7 years',
    link: 'https://www.linux.org/',
    image: 'https://upload.wikimedia.org/wikipedia/commons/e/e6/Linux-Libre_3.0.66-1_Boot.png',
  },
  Keycloak: {
    text: 'Keycloak',
    color: '#607D8B',
    years: '+3 years',
    image: 'https://romeralvarez.me/assets/keycloak/keycloak-logo.png',
    link: 'https://www.keycloak.org/',
    icon: KeycloakIcon,
  },
  Mysql: {
    text: 'MySQL',
    color: 'white',
    link: 'https://www.mysql.com/',
    icon: MysqlOriginal,
    image: 'https://blog.interfell.com/hubfs/MySQL%20un%20gestor%20de%20base%20de%20datos.jpg',
  },
  GooglePlay: {
    text: 'Google Play Console',
    color: '#414141',
    icon: GooglePlayConsoleIcon,
    link: 'https://play.google.com/console/about/',
    image: `https://appsquesipagan.com/wp-content/uploads/2022/07/google-play-console-1.png`,
  },
  Heroku: {
    text: 'Heroku',
    color: 'white',
    icon: HerokuOriginal,
    link: 'https://www.heroku.com/',
    image: `https://i0.wp.com/unaaldia.hispasec.com/wp-content/uploads/2022/05/heroku.png?resize=800%2C302&ssl=1`,
  },
  Gatsby: {
    text: 'Gatsby',
    color: 'white',
    icon: GatsbyOriginal,
    link: 'https://www.gatsbyjs.com/',
    image: 'https://www.dongee.com/tutoriales/content/images/2023/02/gatsby-js.png',
  },
  Postman: {
    text: 'Postman',
    color: '#FF6C37',
    icon: PostmanOriginal,
    link: 'https://www.postman.com/',
    image: 'https://miro.medium.com/v2/resize:fit:1400/1*UjfpcPx0p410o13vpB7mlQ.png',
  },
  Graphql: {
    text: 'GraphQL',
    color: 'white',
    icon: GraphqlPlain,
    link: 'https://graphql.org/',
    image: 'https://www.dongee.com/tutoriales/content/images/2023/11/image-31.png',
  },
  Redis: {
    text: 'Redis',
    color: '#202020',
    icon: RedisOriginal,
    link: 'https://redis.io/',
    image: 'https://proximahost.es/blog/wp-content/uploads/2021/05/redis.png',
  },
  Bootstrap: {
    text: 'Bootstrap',
    color: 'white',
    icon: BootstrapOriginal,
    link: 'https://getbootstrap.com/',
    image: 'https://designmodo.com/wp-content/uploads/2021/03/bootstrap-5-layout.jpg',
  },
  Sentry: {
    text: 'Sentry',
    color: '#574873',
    image: 'https://d15shllkswkct0.cloudfront.net/wp-content/blogs.dir/1/files/2022/05/sentry.png',
    icon: SentryIcon,
    link: 'https://sentry.io/',
  },
  React: {
    text: 'React',
    color: '#474747',
    icon: ReactOriginal,
    link: 'https://reactjs.org/',
    image:
      'https://images.hive.blog/DQmatbJXsYA6v6YocPZ5yvpW2Dbmg287XNYohtmyA46HrNg/reactjs-introduccion-workshop-visual-enginerring.png',
  },
  Firebase: {
    text: 'Firebase',
    color: '#663399',
    icon: FirebaseOriginal,
    link: 'https://firebase.google.com/',
    image: 'https://developers.google.com/static/learn/images/firebase/firebase-hero.jpg',
  },
  TypeScript: {
    text: 'TypeScript',
    color: '#e6e6e6',
    icon: TypescriptOriginal,
    link: 'https://www.typescriptlang.org/',
    image: 'https://img-c.udemycdn.com/course/750x422/986406_89c5_3.jpg',
  },
  JavaScript: {
    text: 'JavaScript',
    color: '#F0DB4F',
    icon: JavascriptPlain,
    link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
    image: `https://blog.interfell.com/hubfs/JavaScript%20un%20lenguaje%20de%20programaci%C3%B3n.jpg`,
  },
  'Ant design': {
    text: 'Ant design',
    color: '#e6e6e6',
    icon: AntdesignOriginal,
    link: 'https://ant.design/',
    image: `https://blog.openreplay.com/images/building-react-components-with-ant-design/images/hero.png`,
  },
  Python: {
    text: 'Python',
    color: '#24262d',
    icon: PythonOriginal,
    link: 'https://www.python.org/',
    image: 'https://www.dongee.com/tutoriales/content/images/2023/01/image-47.png',
  },
  'Node.js': {
    text: 'Node.js',
    color: '#3b3533',
    icon: NodejsOriginal,
    link: 'https://nodejs.org/',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxT3I3S05wanE1dhd109jlO-1ujb4wZt4ibsclFJ7YnQ&s',
  },
  TensorFlow: {
    text: 'TensorFlow',
    color: 'white',
    icon: TensorflowOriginal,
    link: 'https://www.tensorflow.org/',
    image:
      'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgVyX9h9jqUfN0LpVCwPg0iWNd4XDkKWd5hL7Wn9CwGLBZ5NyrEFTHHXu6yCxCaLL2szdaQMCkDuRdV4-JapbV329DYTjaH6ThpbzJlbvgunZK9dUgii1kAqcs-4zhyphenhyphenccaLsfffj7K3-8HFLybyOeaHjVl_n7jdPmD33o0TERamUgTdH7H3qhBLS2GuwtY/s1600/Tensorflow-septmber-update-social%20%282%29%20%281%29.png',
  },
  Django: {
    text: 'Django',
    color: '#092E20',
    icon: DjangoPlain,
    link: 'https://www.djangoproject.com/',
    image: `https://thewhitecode.com/public/uploaded_images/7484_6723093675`,
  },
  Git: {
    text: 'Git',
    color: 'white',
    icon: GitPlain,
    link: 'https://git-scm.com/',
    image: 'https://nodd3r.com/media/blog/Portadas_blog_21.png',
  },
  GitHub: {
    text: 'GitHub',
    color: 'white',
    icon: GithubOriginal,
    link: 'https://github.com/',
    image: `https://www.bew-web-agency.fr/wp-content/uploads/2024/02/GitHub.jpg`,
  },
  GitLab: {
    text: 'GitLab',
    color: '#483a73',
    icon: GitlabOriginal,
    link: 'https://about.gitlab.com/',
    image: `https://i.blogs.es/a18540/gitlab/1366_2000.png`,
  },
  AWS: {
    text: 'AWS',
    color: '#232F3E',
    icon: FaAws as unknown as React.ComponentType<any>,
    link: 'https://aws.amazon.com/',
    image: `https://assets.intersystems.com/26/bd/6a6aa762425f87ad7d5c2fe65f8c/awslogo-image.jpg`,
  },
  JIRA: {
    text: 'Jira',
    color: '#00599C',
    icon: JiraOriginal,
    link: 'https://www.atlassian.com/software/jira',
    image: `https://assets-global.website-files.com/619cef5c40cb8925cd33ece3/637648a1090aeed11875e39c_what-is-jira-and-how-agile-teams-use-it.jpg`,
  },
  Slack: {
    text: 'Slack',
    color: 'white',
    icon: SlackOriginal,
    link: 'https://slack.com/',
    image: 'https://conexion-hr.com/wp-content/uploads/2020/07/2019-01-brandrefresh-slack-brand-refresh-unfurl-1.png',
  },
  Terraform: {
    text: 'Terraform',
    color: 'white',
    icon: TerraformOriginal,
    link: 'https://www.terraform.io/',
    image: 'https://miro.medium.com/v2/resize:fit:1400/1*QMk06VBnuiZgumwBJTAGpw.png',
  },
  'CI/CD': {
    text: 'CI/CD',
    color: 'white',
    icon: GithubactionsOriginal,
    link: 'https://www.redhat.com/es/topics/devops/what-is-ci-cd',
    image: `https://cd.foundation/wp-content/uploads/sites/78/2020/09/devops.png`,
  },
  Laravel: {
    text: 'Laravel',
    color: 'white',
    icon: LaravelOriginal,
    link: 'https://laravel.com/',
    image:
      'https://codersfree.nyc3.cdn.digitaloceanspaces.com/posts/conoce-las-6-principales-diferencias-entre-laravel-9-y-laravel-10.jpg',
  },
  Confluence: {
    text: 'Confluence',
    color: '#172B4D',
    icon: ConfluencePlain,
    link: 'https://www.atlassian.com/software/confluence',
    image: 'https://cms.rootstack.com/sites/default/files/inline-images/confluence-vector-logo.png',
  },
  Redash: {
    text: 'Redash',
    color: '#007396',
    link: 'https://redash.io/',
    image: 'https://www.arsys.es/blog/file/uploads/2018/07/redash-01.png',
    icon: RedashIcon,
  },
  AppCenter: {
    text: 'AppCenter',
    color: 'white',
    link: 'https://appcenter.ms/',
    image: `https://www.vectorlogo.zone/logos/appcenterms/appcenterms-ar21.png`,
    icon: AppCenterIcon,
  },
  Docker: {
    text: 'Docker',
    color: 'white',
    icon: DockerOriginal,
    link: 'https://www.docker.com/',
    image: 'https://miro.medium.com/v2/resize:fit:1000/1*sJrhAmlqJlW24ahHz-L8pQ.png',
  },
  Angular: {
    text: 'Angular',
    color: '#015aa6',
    icon: AngularOriginal,
    link: 'https://angular.io/',
    image: `https://c4.wallpaperflare.com/wallpaper/10/887/781/angular-javascript-html-wallpaper-preview.jpg`,
  },
  IONIC: {
    text: 'Ionic',
    color: 'white',
    icon: IonicOriginal,
    link: 'https://ionicframework.com/',
    image: 'https://profile.es/wp-content/media/ionic-min.png',
  },
  ReactNative: {
    text: 'React Native',
    color: '#01a4d3',
    icon: FaReact as unknown as React.ComponentType<any>,
    link: 'https://reactnative.dev/',
    image: 'https://miro.medium.com/v2/1*AjesIvV-kkwk6LLvNf1t4A.png',
  },
  Serverless: {
    text: 'Serverless',
    color: 'black',
    link: 'https://www.serverless.com/',
    image: 'https://assets.serverless-extras.com/website/general/social-card-serverless-company.png',
    icon: ServerlessIcon,
  },
  Dynamo: {
    text: 'DynamoDB',
    color: 'white',
    link: 'https://aws.amazon.com/dynamodb/',
    icon: DynamoIcon,
    image: 'https://awsnewbies.com/wp-content/uploads/2018/08/dynamodb.jpg',
  },
  Rancher: {
    text: 'Rancher',
    color: 'white',
    icon: RancherOriginal,
    link: 'https://rancher.com/',
    image: 'https://www.devopsschool.com/blog/wp-content/uploads/2022/03/Rancher.jpg',
  },
  Kubernetes: {
    text: 'Kubernetes',
    color: 'white',
    image: `https://www.strsistemas.com/sites/default/files/logo_kubernetes_copia.jpg`,
    icon: KubernetesOriginal,
    link: 'https://kubernetes.io/',
  },
  Symfony: {
    text: 'Symfony',
    color: '#000000',
    icon: FaSymfony as unknown as React.ComponentType<any>,
    link: 'https://symfony.com/',
    image: 'https://www.coriaweb.hosting/wp-content/uploads/2016/11/symfony_logo.png',
  },
  Mongo: {
    text: 'MongoDB',
    color: 'white',
    icon: MongodbOriginal,
    link: 'https://www.mongodb.com/',
    image: 'https://i.blogs.es/a49483/logo-mongodb-tagline-2/650_1200.png',
  },
  Spotify: {
    text: 'Spotify API',
    color: 'black',
    icon: SpotifyGreenIcon,
    link: 'https://developer.spotify.com/',
    image: 'https://www.markhneedham.com/blog//uploads/2020/01/spotify-logo.png',
  },
  REDUX: {
    text: 'Redux',
    color: 'white',
    icon: ReduxOriginal,
    link: 'https://redux.js.org/',
    image: 'https://i1.wp.com/blog.enriqueoriol.com/wp-content/uploads/2018/08/reduxLogo.png?fit=1024%2C684',
  },
  SASS: {
    text: 'Sass',
    color: 'white',
    icon: SassOriginal,
    link: 'https://sass-lang.com/',
    image: 'https://miro.medium.com/v2/resize:fit:1400/1*MCiNLBzUI-LWK_PhVwq0xA.png',
  },
  Android: {
    text: 'Android',
    color: 'white',
    icon: AndroidOriginal,
    link: 'https://developer.android.com/',
    image: 'https://graffica.info/wp-content/uploads/2017/07/logo-Android-Andy.jpg',
  },
  IOS: {
    text: 'iOS',
    color: '#000000',
    icon: FaApple as unknown as React.ComponentType<any>,
    link: 'https://developer.apple.com/',
    image: `https://developer.apple.com/news/images/og/apple-developer-og.png`,
  },
  Telegram: {
    text: 'Telegram Bot API',
    color: '#0088cc',
    link: 'https://core.telegram.org/bots/api',
    icon: FaTelegram as unknown as React.ComponentType<any>,
    image: 'https://i.blogs.es/9f5efd/titulo/650_1200.png',
  },
  Postgres: {
    text: 'PostgreSQL',
    color: 'white',
    link: 'https://www.postgresql.org/',
    icon: PostgresqlOriginal,
    image: 'https://kinsta.com/wp-content/uploads/2022/02/postgres-logo.png',
  },
  Express: {
    text: 'Express',
    color: '#2c2c2c',
    link: 'https://expressjs.com/',
    image: `https://www.dongee.com/tutoriales/content/images/2023/11/image-59.png`,
    icon: ExpressIcon,
  },
  Mercadopago: {
    text: 'Mercado Pago API',
    color: 'white',
    link: 'https://www.mercadopago.com.ar/developers/es/guides',
    image: 'https://newpap.s3.us-west-2.amazonaws.com/wp-content/uploads/2022/05/12193626/mercado-pago.jpg',
    icon: MercadoPagoIcon,
  },
  Expo: {
    text: 'Expo',
    color: '#000000',
    link: 'https://expo.io/',
    icon: ExpoIcon,
    image: 'https://strapi.dhiwise.com/uploads/618fa90c201104b94458e1fb_64fec43a0e499e8f8b132acb_expo_git_OG_Image_cb3dfa26e3.jpg',
  },
  Vercel: {
    text: 'Vercel',
    color: '#000000',
    link: 'https://vercel.com/',
    icon: VercelIcon,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHWvBRldr0qHYB-_UUDqEsXeeVw8Vq7LsePg&s',
  },
  Cloudflare: {
    text: 'Cloudflare',
    color: '#F48120',
    link: 'https://cloudflare.com/',
    icon: CloudflareIcon,
    image:
      'https://cf-assets.www.cloudflare.com/slt3lc6tev37/2FNnxFZOBEha1W2MhF44EN/e9438de558c983ccce8129ddc20e1b8b/CF_MetaImage_1200x628.png',
  },
  Electron: {
    text: 'Electron',
    color: '#47848F',
    link: 'https://www.electronjs.org/',
    icon: ElectronIcon,
    image: 'https://miro.medium.com/1*pZSdLbXSCEDZRFjTuapE5Q.png',
  },
  Java: {
    text: 'Java',
    color: '#ED8B00',
    icon: JavaOriginal,
    link: 'https://www.java.com/',
    image: 'https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg',
  },
  SpringBoot: {
    text: 'Spring Boot',
    color: '#6DB33F',
    icon: SpringOriginal,
    link: 'https://spring.io/projects/spring-boot',
    image: 'https://spring.io/img/homepage/icon-spring-boot.svg',
  },
  Arduino: {
    text: 'Arduino',
    color: '#00979C',
    icon: ArduinoOriginal,
    link: 'https://www.arduino.cc/',
    image: 'https://upload.wikimedia.org/wikipedia/commons/1/1b/Arduino_Logo.svg',
  },
  Vite: {
    text: 'Vite',
    color: '#646CFF',
    icon: ViteOriginal,
    link: 'https://vitejs.dev/',
    image: 'https://vitejs.dev/og-image.png',
  },
  Tailwind: {
    text: 'Tailwind CSS',
    color: '#38BDF8',
    icon: TailwindcssOriginal,
    link: 'https://tailwindcss.com/',
    image: 'https://tailwindcss.com/opengraph-image.jpg',
  },
  GSAP: {
    text: 'GSAP',
    color: '#88CE02',
    icon: SiGreensock as unknown as React.ComponentType<any>,
    link: 'https://gsap.com/',
    image: 'https://gsap.com/community/uploads/monthly_2020_03/tweenmax.png.cf27916e926fbb328ff214f66b4c8429.png',
  },
  FastAPI: {
    text: 'FastAPI',
    color: '#009688',
    icon: FastapiOriginal,
    link: 'https://fastapi.tiangolo.com/',
    image: 'https://fastapi.tiangolo.com/img/icon-white.svg',
  },
  RabbitMQ: {
    text: 'RabbitMQ',
    color: '#FF6600',
    icon: RabbitmqOriginal,
    link: 'https://www.rabbitmq.com/',
    image: 'https://www.rabbitmq.com/img/logo-rabbitmq.svg',
  },
  C: {
    text: 'C',
    color: '#A8B9CC',
    icon: COriginal,
    link: 'https://en.wikipedia.org/wiki/C_(programming_language)',
    image: 'https://upload.wikimedia.org/wikipedia/commons/1/19/C_Logo.png',
  },
  'C++': {
    text: 'C++',
    color: '#00599C',
    icon: CplusplusOriginal,
    link: 'https://isocpp.org/',
    image: 'https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg',
  },
};
